import { useEffect } from 'react';
import { useQuery } from 'urql';

import { EnergyLabelDocument } from '~src/graphql';
import { ResidenceInput } from '~src/model';

import { useQueryToaster } from './useGraphQLToaster';

export const useEnergyLabel = (
  addressId?: string,
  residence?: Partial<ResidenceInput>,
  setResidence?: (input: Partial<ResidenceInput>) => void
) => {
  const [result] = useQuery({
    query: EnergyLabelDocument,
    variables: { addressId: addressId ?? '' },
    requestPolicy: 'cache-first',
    pause: !addressId || !residence || !!residence?.energyLabel || !setResidence,
  });

  useQueryToaster(result, {
    error: { message: 'Kunne ikke finde Energimærke' },
  });

  useEffect(
    function updateEnergyLabel() {
      if (!addressId || !residence || residence?.energyLabel || !result || result.fetching || !setResidence) {
        return;
      }

      const { data } = result ?? {};
      const { energyLabel } = data ?? {};

      if (energyLabel) {
        setResidence({ ...residence, energyLabel });
      }
    },
    [addressId, residence, result, setResidence]
  );
};
